/* eslint-disable require-jsdoc */

function formatDistance(rawDistance) {
  const distInt = parseFloat(rawDistance);
  return Math.round(distInt * 10) / 10;
}
export {formatDistance};
